export default { termsWireToInt };

function termsWireToInt (wireTerms) {
  if (!wireTerms) return null;

  const { title, note, description } = wireTerms;
  return {
    title: title ? title._text : '',
    note: note ? note._text : '',
    description: description ? description._text : '',
  };
}



// WEBPACK FOOTER //
// ./src/converter/TermsConverter.js